import { initializeApp, getApps } from "firebase/app";
import { initializeFirestore, getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// --- CONFIGURACIÓN CORRECTA Y SINCRONIZADA DESDE TU CONSOLA DE FIREBASE ---
const firebaseConfig = {
  apiKey: "AIzaSyCHTs4laHNTiyUSPXNxfCg6eWPv6eqBSik",
  authDomain: "project-master-b8fe9.firebaseapp.com",
  projectId: "project-master-b8fe9",
  storageBucket: "project-master-b8fe9.firebasestorage.app",
  messagingSenderId: "432671473758",
  appId: "1:432671473758:web:53838ef429780ca11af4cf",
  measurementId: "G-FGJEBYSSKL"
};

// Lógica anti-duplicados para evitar errores de recarga en caliente
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Firestore con auto-detección de long-polling: evita los errores de conexión
// WebChannel/QUIC (ERR_QUIC_PROTOCOL_ERROR / QUIC_TOO_MANY_RTOS) en redes con
// VPN/proxy. Solo cae a long-polling cuando hace falta; no afecta el caso normal.
// El guard cubre el hot-reload (Firestore ya inicializado en el mismo app).
let db;
try {
  db = initializeFirestore(app, { experimentalAutoDetectLongPolling: true });
} catch (_) {
  db = getFirestore(app);
}

// Exportar los servicios para que toda la app los use
export const storage = getStorage(app);
export const auth = getAuth(app);
// Instancia de Functions en la región de los callables (us-central1). Los componentes
// hacen getFunctions(getApp(), 'us-central1'); Firebase cachea por app+región, así que
// conectar ESTA instancia al emulador (abajo) hace que todos los callables lo usen.
export const functions = getFunctions(app, "us-central1");

// ── Modo emulador (solo dev local) ───────────────────────────────────────────
// Se activa con REACT_APP_USE_EMULATORS=true (ver npm run start:emulator). Apunta
// Firestore/Auth/Functions a los emuladores locales — NUNCA toca producción. En
// build de producción el flag no está, así que este bloque no corre.
if (process.env.REACT_APP_USE_EMULATORS === "true") {
  const host = "127.0.0.1";
  connectFirestoreEmulator(db, host, 8080);
  connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
  connectFunctionsEmulator(functions, host, 5001);
  // eslint-disable-next-line no-console
  console.info("🧪 Firebase apuntando a EMULADORES locales (Firestore 8080 · Auth 9099 · Functions 5001).");
}

export { db };

